import { Grid, Button } from '@material-ui/core';
import presidente from 'imagens/presidente.png'
import { useDevice } from 'components/DeviceContext.js';


const PalavraPresidente = () => {
    const { isMobile, isTablet, isLaptop } = useDevice();



    return (

        <Grid container
            style={{
                justifyContent: 'center',
                backgroundColor: 'var(--azul)',
                height: isMobile ? '100vh' : isTablet ? '70vh' : '52vh'
            }}>




            <Grid item xs={10} sm={10} md={4} lg={4} xl={3}
                style={{

                }}>
                <Grid item
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        textAlign: isMobile || isTablet ? 'center' : 'end',
                        alignItems: isMobile || isTablet ? 'center' : 'end',
                        paddingRight: isMobile? '' : '1em'

                    }}>
                    <h1 style={{
                        color: 'var(--laranja)',
                        fontSize: isMobile ? '1.8em' : isTablet ? '3em' : isLaptop ? '2.2em' :  '2.6em',
                    }}>
                        Palavra do Presidente
                    </h1>
                    <p style={{
                        color: 'var(--branco)',
                        fontSize: isMobile ? '1.6em' : isTablet ? '2.6em' : isLaptop ? '1.6em' : '2.2em'
                    }}>
                        Responsabilidade
                        e eficiência na
                        gestão do Fundo dos
                        Direitos da Criança
                        e do Adolescente
                    </p>
                    <Button style={{
                        maxWidth: '54%',
                        padding: '0.4em 2em',
                        backgroundColor: 'var(--laranja)',
                        marginBottom: isMobile || isTablet ? '3em' : '',
                        borderRadius: '8em'

                    }}
                    >
                        <a style={{
                            color: 'var(--branco)',
                            fontWeight: '800',
                            fontSize:  isMobile ? '1.2em' : '1.6em',
                            textTransform: 'lowercase',
                        }} href="/Palavraspresidente" target="_blank" rel="noopener noreferrer"><span style={{textTransform: 'uppercase'}}>L</span>eia mais...</a>
                    </Button>
                </Grid>

            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={5} xl={4}>
                <img src={presidente} alt='Presidente CNM '
                    style={{
                        width: isMobile ? '100%' : isTablet ? '100%' : isLaptop ? '75%' : '100%',
                        marginTop: isMobile ? '' : isLaptop ? '-26px' : '-80px'
                    }} />
            </Grid>
        </Grid >




    )
}

export default PalavraPresidente
